import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";

export default function ConfirmPublishMagnetModal({ open, onClose, handlePublish }: any) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative  rounded-2xl bg-primary pb-6 pl-7 pr-7 pt-6 shadow-modal md:w-[600px]">
        <div className="flex justify-between">
          <div className=" w-[90%]">
            <section className="w-full font-satoshi text-2xl font-bold text-white">
              Are your sure you want to publish?
            </section>
          </div>
          <span role="button" tabIndex={0} onKeyDown={() => {}} onClick={onClose} className="cursor-pointer">
            X
          </span>
        </div>
        <section className="mt-5 w-full font-satoshi text-lg font-450 text-white">
          Post this you won’t be able to edit the Magnet details
        </section>

        <div className="mt-20 flex justify-end gap-3">
          <Button
            additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            variant="whiteOutline"
            text="CANCEL"
            onClick={onClose}
          />
          <Button
            additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            variant="magnetiqSolid"
            text="CONFIRM PUBLISH"
            onClick={handlePublish}
          />
        </div>
      </div>
    </Modal>
  );
}
